import { NotFinalGuidedSellingStep } from "@swo/storefront";
import { ReactTFC } from "../../../../utils/fp/missing-ts-parts";
import { css } from "@emotion/react";
import React, { useEffect, useState } from "react";
import { CSS_COLORS } from "../../../../styles/styles-css-variables";
import { ReactSVG } from "react-svg";
import cn from "classnames";
import { CSS_MQ } from "../../../../styles/breakpoints";
import { GuidedSellingStepIconChoice } from "@swo/storefront";
import { fontSize } from "../../../../styles/fonts";

export const SwitcherChoice: ReactTFC<{
  currentStep: NotFinalGuidedSellingStep;
  currentChoice: string | undefined;
  onMakeChoice: (choiceId: string) => void;
  onChoiceHovered: (choice: GuidedSellingStepIconChoice) => void;
}> = props => {
  const [value, setValue] = useState(0);

  useEffect(() => {
    if (typeof props.currentChoice === "undefined") {
      props.onMakeChoice(props.currentStep.choices[0].id);
    }
  }, [props.currentChoice]);

  useEffect(() => {
    const maybe: GuidedSellingStepIconChoice | undefined = props.currentStep.choices[value];

    if (maybe && maybe.id !== props.currentChoice) {
      props.onMakeChoice(maybe.id);
    }
  }, [value]);

  return (
    <div
      css={css`
        --size: 300px;
        --height: 60px;

        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        input[type="range"] {
          outline: 0;
          border: 0;
          border-radius: 500px;

          width: var(--size);
          max-width: 100%;

          margin: 0;
          transition: box-shadow 0.2s ease-in-out;

          // Chrome
          @media screen and (-webkit-min-device-pixel-ratio: 0) {
            & {
              overflow: hidden;
              height: var(--height);

              -webkit-appearance: none;
              background-color: hsl(0deg 0% 100% / 20%);
              border: 1px solid hsl(0deg 0% 70%);
            }

            &::-webkit-slider-runnable-track {
              height: var(--height);
              -webkit-appearance: none;

              color: ${CSS_COLORS.White};
              border: #fff;
              //transition: box-shadow 0.2s ease-in-out;
            }

            &::-webkit-slider-thumb {
              width: var(--height);
              -webkit-appearance: none;
              height: var(--height);
              cursor: ew-resize;
              background: #fff;
              border-color: hsl(0deg 0% 70%);

              box-shadow:
                -340px 0 0 320px ${CSS_COLORS.White},
                inset 0 0 0 40px ${CSS_COLORS.White};

              // Want to see magic? Remove this line and check how it renders on iOS Safari <3
              border-top-left-radius: 50%;

              border-radius: 50%;

              transition: box-shadow 0.2s ease-in-out;
              position: relative;
            }

            &:active::-webkit-slider-thumb {
              background: #fff;
              box-shadow:
                -340px 0 0 320px ${CSS_COLORS.White},
                inset 0 0 0 3px ${CSS_COLORS.White};
            }
          }

          &::-moz-range-progress {
            background-color: ${CSS_COLORS.White};
          }
          &::-moz-range-track {
            background-color: ${CSS_COLORS.White};
          }
        }
      `}
    >
      <input
        type="range"
        value={value}
        step={1}
        max={props.currentStep.choices.length - 1}
        onChange={e => {
          e.preventDefault();
          e.stopPropagation();

          const n = Number.parseInt(e.target.value);

          if (n >= 0 && n <= props.currentStep.choices.length - 1) {
            setValue(n);
          }
        }}
      />

      <span
        className={cn({ "with-icons": props.currentStep.choices.some(v => v.icon) })}
        css={[
          fontSize.x2,
          css`
            display: flex;
            justify-content: space-between;
            margin-top: 20px;

            &:not(.with-icons) {
              padding-left: 12px;
              padding-right: 12px;
              width: var(--size);
            }

            &.with-icons {
              margin-left: -12px;
              margin-right: -12px;
              width: calc(var(--size) + 24px);
            }

            color: ${CSS_COLORS.White};
          `,
        ]}
      >
        {props.currentStep.choices.map((c, idx) => {
          return (
            <button
              onMouseEnter={() => props.onChoiceHovered(c)}
              onClick={() => {
                setValue(idx);
              }}
              key={c.id}
              css={css`
                display: flex;
                flex-direction: column;
                align-items: center;
              `}
            >
              {c.icon && (
                <ReactSVG
                  src={c.icon.url}
                  title={c.icon.title}
                  alt={c.icon.title}
                  css={css`
                    width: 70px;
                    height: 35px;
                    ${CSS_MQ.atLeastMd} {
                      width: 100px;
                      height: 50px;
                    }

                    justify-self: center;
                    margin-bottom: 8px;

                    svg {
                      width: 100%;
                      height: 100%;
                      object-fit: contain;

                      color: var(--text-color);
                    }
                  `}
                />
              )}

              <span>{c.label}</span>
            </button>
          );
        })}
      </span>
    </div>
  );
};
